<div class="calendar-form-wrapper dark-mode-wrapper"
  [ngClass]="{ 'disabled': isCalendarDisabled && !disableFullOpacity, 'disable-full-opacity': disableFullOpacity }">
  <div class='datepicker-cross-icon' *ngIf="openDefault && !hideCloseIcon"
    (click)='closeDatePicker()'>
    <span class='lato-16-n-vw'>X</span>
  </div>
  <form class="form-inline calendar-form dark-mode"
    [ngClass]="{ 'w-100': toggleButton && displayInputArea }">
    <div class="form-group" [ngClass]="{'w-100': toggleButton, 'header-dates-static': titleStatic}">
      <div class="input-group start-date timeline-datepicker-width show-navigation"
        [ngClass]="{'w-100' : toggleButton}">
        <span class="selected-date lato-14-n-vw" *ngIf="topPlaceholder">{{topPlaceholder}}
          <span class="date lato-14-b-vw">
            {{ topPlaceholder ? (
            netskopeLabelDate | date:'MMM yyyy' | uppercase
            ) : '' }}
          </span>
        </span>
        <!-- separator line in dark mode-->
        <div *ngIf='openDefault' class='d-flex justify-content-center separator-cont'>
          <div class="datepicker-separator">&nbsp;</div>
        </div>
        <input class="form-control"
          [ngClass]="{'display-input-area': toggleButton && displayInputArea }" type="text"
          id="{{dateType}}" name="{{dateType}}" [dayTemplate]="iniDateCustomDay"
          [disabled]="isCalendarDisabled || disableFullOpacity" placeholder="{{placeHolder}}"
          (dateSelect)="dateUpdated($event)" ngbDatepicker #dateInput="ngbDatepicker"
          [outsideDays]="'hidden'" [autoClose]="toggleButton" [(ngModel)]="selectedDate"
          [minDate]="inputMinDate" [maxDate]="inputMaxDate" [startDate]="initialDateValue"
          [markDisabled]="disableDates(selectedDatesArray)" readonly
          (navigate)="calendarMonthNavigation($event, LabelMonthShow)" />
      </div>
    </div>
  </form>
  <ng-template #iniDateCustomDay let-date let-currentMonth="currentMonth" let-selected="selected"
    let-disabled="disabled" let-focused="focused">
    <div class="custom-day"
      [class.bg-primary]="topPlaceholder!='' ? selected : dateExistInCalendar(date)"
      [class.text-muted]="disabled">
      {{ date.day }}
    </div>
    <!-- [class.focused]="focused" -->
  </ng-template>
</div>